export default {
    nav: {
        main: {
            timeRegistration: 'Tijdsregistratie',
            roadmap: 'Roadmap',
            operations: 'Operatie',
            planning: 'Planning',
            crm: 'CRM',
            infra: 'Infra',
            assets: 'Stamgegevens',
            iso: 'ISO',
            docs: 'Docs',
        },
        assets: {
            users: 'Gebruikers',
            globalValues: 'Instellingen',
            globalFiles: 'Bijzondere bestanden',
            emailTemplates: 'Emailsjablonen',
        },
        audit: {
            accessLog: 'Toegangslog',
        },
        account: {
            account: 'Account',
            changelog: 'Changelog'
        },
        crm: {
            entities: 'Entiteiten',
            companies: 'Bedrijven',
            contacts: 'Contacten',
            teams: 'Teams',
            contracts: 'Contracts'
        },
        operations: {
            tickets: 'Tickets',
            tags: 'Tags',
            milestones: 'Milestones',
            milestoneStatuses: 'Milestone statussen',
            project: 'Projecten',
            userSchedule: 'Werkschema'
        },
        planning: {
            projectOverview: 'Projectenoverzicht',
            developerOverview: 'Ontwikkelaarsoverzicht',
            sprintPlanning: 'Sprint Planning',
            capacityPlanner: 'Capaciteitsplanner',
        },
        timeRegistration: {
            myTime: 'Mijn Tijd',
            overview: 'Overzicht'
        },
        infra: {
            server: 'Servers'
        },
        modules: {
            overview: 'Modules',
            whale: {
                overview: 'Whale'
            }
        },
        iso: {
            checks: 'Checks',
            documents: {
                title: 'Documenten',
                header: 'Documentenregister',
                documents: 'Documenten',
                chapters: 'Hoofdstukken'
            }
        }
    },
    user: {
        overview: {
            title: 'Gebruikers',
            addButton: 'Nieuwe gebruiker',
        },
        create: {
            title: 'Gebruiker aanmaken',
        },
        edit: {
            title: 'Gebruiker aanpassen',
        },
        field: {
            fullName: { label: 'Naam' },
            firstName: { label: 'Voornaam' },
            lastName: { label: 'Achternaam' },
            email: { label: 'E-mail' },
            language: { label: 'Taal' },
            password: { label: 'Wachtwoord' },
            dateJoined: { label: 'Toegevoegd Op' },
            abbreviation: { label: 'Afkorting' },
            team: { label: 'Team' },
            extraTimeLastMonth: { label: 'Extra tijd vorige maand' },
            extraTimeThisMonth: { label: 'Extra tijd deze maand' },
            missingTimeLastMonth: { label: 'Missende tijd vorige maand' },
            missingTimeThisMonth: { label: 'Missende tijd deze maand' },
            groups: {
                label: 'Groepen',
                value: {
                    operation_manager: 'Operation manager',
                    team_lead: 'Team lead',
                    employee: 'Werkenemer',
                    superuser: 'Supergebruiker',
                    admin: 'Administrator',
                    manager: 'Manager',
                    experimental: 'Experimenteel',
                    iso: 'ISO',
                    sales: 'Sales',
                    planner: 'Planner',
                    n8n_integration: 'n8n Integratie'
                },
                empty: 'Geen groepen toegekend',
            },
            isActive: {
                label: 'Users',
                options: {
                    all: 'Alle',
                    yes: 'Actief',
                    no: 'Niet Actief',
                }
            },
            mfa: {
                label: 'MFA-methoden',
            },
            external: { label: 'Extern' },
            exactId: { label: 'Exact ID' },
            autoClearTimeRegistration: { label: 'Automatisch Tijdregistratie Leegmaken' },
            separateProjectTicketSelects: { label: 'Selecteer het project en het ticket in een apart veld' },
            timeSuggestionInstruction: {
                label: 'AI Tijdsuggestie Instructies',
                placeholder: 'Voer aangepaste instructies in voor AI tijdsuggesties (bijv. "Focus op project X deze week", "Geef de voorkeur aan langere gedetailleerde omschrijvingen", etc.)'
            },
        },
        login: {
            title: 'Inloggen',
            forgotPasswordLink: 'Wachtwoord vergeten?',
            errors: {
                invalidCredentials: 'E-mail of wachtwoord is niet correct',
                unknown: 'Onbekende fout, status code: {{status}}',
            },
            loginButton: 'Inloggen',
        },
        passwordForgot: {
            title: 'Wachtwoord vergeten',
            requestButton: 'Verstuur e-mail',
            requestedEmailText:
                'Er is een email met een wachtwoord resetcode verzonden naar uw e-mailadres.',
            loggedInError: 'Je bent ingelogd. Je kunt alleen wachtwoord vergeten aanvragen als je uitgelogd bent.',
        },
        resetPassword: {
            title: 'Wachtwoord Opnieuw Instellen',
            resetButton: 'Opnieuw Instellen',
            saveSuccess: 'Wachtwoord is opnieuw ingesteld',
            loggedInError: 'Je bent ingelogd. Je kunt alleen jouw wachtwoord herstellen als je uitgelogd bent.',
        },
        changePassword: {
            title: 'Wachtwoord aanpassen',
            field: {
                passwordOld: {
                    label: 'Huidig wachtwoord',
                },
                passwordNew: {
                    label: 'Nieuw wachtwoord',
                },
            },
            saveButton: 'Opslaan',
        },
        account: {
            title: 'Profiel',
            logoutButton: 'Uitloggen',
            info: {
                title: 'Gegevens',
            },
            password: {
                title: 'Wachtwoord veranderen',
            },
            logout: {
                title: 'Uitloggen',
                confirm: 'Weet u zeker dat u wilt uitloggen?'
            },
        },
        multiFactorAuth: {
            code: {
                app: 'Verificatiecode',
                email: 'Inlogcode',
                newCode: 'Nieuwe code aanvragen',
            },
            expiring: 'Je authenticatiecode is nog {{ minutes }} minuten geldig',
            explanation: {
                app: 'Voer de verificatiecode in die uw verificatie-app voor u heeft gegenereerd.',
                email: 'Uw inlogcode is per e-mail naar u verzonden.',
            },
            explanationFailed: 'We hebben geprobeerd een inlogcode naar het geregistreerde e-mailadres te sturen, maar dit is mislukt.',
            timeout: 'U hebt het te vaak geprobeerd. U kunt het over een paar minuten opnieuw proberen.',
            invalid: {
                app: 'De verificatiecode is verkeerd of is verlopen. Probeer het opnieuw.',
                email: 'De inlogcode is verkeerd of is verlopen. Probeer het opnieuw of vraag een nieuwe code aan.',
            },
            resend: 'Verstuur opnieuw',
            title: 'Bevestig',
        },
    },
    globalValue: {
        edit: {
            title: '{{key}} aanpassen',
        },
        overview: {
            title: 'Instellingen',
        },
        field: {
            key: {
                label: 'Naam instelling',
            },
            value: {
                label: 'Waarde',
            },
            writable: {
                label: 'Schrijfbaar?',
            },
            readable: {
                label: 'Leesbaar?',
            },
        },
    },
    globalFile: {
        edit: {
            title: 'Bijzonder bestand bewerken',
        },
        overview: {
            title: 'Bijzondere bestanden',
        },
        field: {
            key: {
                label: 'Naam voor bestand',
            },
            value: {
                label: 'Bestand',
            },
            writable: {
                label: 'Schrijfbaar?',
            },
            readable: {
                label: 'Leesbaar?',
            },
        },
    },
    accessLogEntry: {
        overview: {
            title: 'Auditlog',
        },
        field: {
            originalUser: {
                label: 'Oorspronkelijke gebruiker',
            },
            masqueradingAsUser: {
                label: 'Gemaskeerd als gebruiker',
            },
            ipAddress: {
                label: 'IP-adres',
            },
            method: {
                label: 'HTTP-methode',
            },
            endpoint: {
                label: 'Endpoint',
            },
            statusCode: {
                label: 'Statuscode',
            },
            additionalInfo: {
                label: 'Extra informatie',
            },
            requestTime: {
                label: 'Tijdstip van toegang',
            },
        },
    },
    myFilter: {
        custom: 'Nieuw',
        action: {
            unsetDefault: 'Gebruik niet als standaard',
            setDefault: 'Gebruik als standaard',
            setCurrent: 'Sla huidige filters op',
            delete: 'Verwijderen',
        },
    },
    tooltips: {
        masquerade: 'Voordoen als',
        edit: 'Aanpassen',
        delete: 'Verwijderen',
        view: 'Bekijk',
        restore: 'Herstel',
        history: 'Geschiedenis',
        copy: 'Kopiëren',
    },
    form: {
        search: 'Zoek',
        repeat: 'Herhaal',
        fileType: {
            pdf: 'PDF',
            image: 'IMG',
            xls: 'XLS',
            any: 'Anders',
            none: 'Nog geen bestand geüpload',
        },
        saveButton: 'Opslaan',
        saveAndBackButton: 'Opslaan & Terug',
        saveAndNewButton: 'Opslaan & Nieuw',
        deleteButton: 'Verwijderen',
        multiPick: {
            searchPlaceholder: 'Selecteer…',
            selectedText: '$1 uit $2 geselecteerd',
            noneSelectedText: 'Geen geselecteerd',
            selectAllButton: 'Alle',
            selectNoneButton: 'Geen',
        },
        notifications: {
            saveSuccess: 'Succesvol opgeslagen',
            deleteSuccess: 'Succesvol verwijderd',
            saveError: 'Fout met opslaan ({{status}})',
            saveValError: 'Niet alle informatie is correct ingevuld',
            saveAuthError: 'Niet geauthorizeerd',
            newAppVersion:
                'Nieuwe versie beschikbaar, klik om de pagina te verversen',
        },
        draftJs: {
            style: {
                'header-one': { label: 'H1' },
                'header-two': { label: 'H2' },
                'header-three': { label: 'H3' },
                'header-four': { label: 'H4' },
                'header-five': { label: 'H5' },
                'header-six': { label: 'H6' },
                blockquote: { label: 'Blockquote' },
                'unordered-list-item': { label: 'UL' },
                'ordered-list-item': { label: 'OL' },
                'code-block': { label: 'Code Block' },
                BOLD: { label: 'Bold' },
                ITALIC: { label: 'Italic' },
                UNDERLINE: { label: 'Underline' },
                CODE: { label: 'Monospace' },
            },
        },
        submitButton: 'Verstuur',
        cancelButton: 'Annuleren',
        unsavedChangesWarning: 'Je hebt niet-opgeslagen wijzigingen. Wil je deze weggooien?',
        confirmQuestion: 'Weet je het zeker?',
        continueButton: 'Doorgaan',
        discardChangesButton: 'Wijzigingen weggooien',
        addButton: 'Toevoegen',
        downloadButton: 'Download',
        deleteConfirmation: 'Weet u zeker dat u dit wilt verwijderen?',
        restoreConfirmation: 'Weet u zeker dat u dit wilt herstellen?',
        startDate: 'Startdatum',
        endDate: 'Einddatum',
        no: 'Nee',
        yes: 'Ja',
        either: 'Beide',
        smartDateRange: {
            value: {
                today: 'Vandaag',
                yesterday: 'Gisteren',
                past_7_days: 'Laatste 7 Dagen',
                past_30_days: 'Laatste 30 Dagen',
                custom: 'Anders',
                last_month: 'Vorige Maand',
                last_quarter: 'Vorig Kwartaal',
                last_year: 'Vorig Jaar',
                this_month: 'Huidige Maand',
                this_quarter: 'Huidig Kwartaal',
                this_year: 'Huidig Jaar',
                all_time: 'Altijd',
            },
            period: {
                last: 'Vorig',
                this: 'Huidig',
                value: {
                    month: 'Maand',
                    quarter: 'Kwartaal',
                    year: 'Jaar',
                },
            },
        },
    },
    crash: {
        heading: 'Applicatie gecrasht',
        subHeading1: 'Onze excuses, maar de applicatie is gecrasht.',
        subHeading2: 'Ons team is op de hoogte gesteld.',
        reload: 'Herlaad pagina'
    },
    emailTemplate: {
        overview: {
            title: 'E-mailsjablonen',
            addButton: 'Nieuw sjabloon',
        },
        create: { title: 'E-mailsjabloon aanmaken' },
        edit: { title: 'E-mailsjabloon aanpassen' },
        add: { title: 'E-mailsjabloon toevoegen' },
        field: {
            id: { label: 'ID' },
            isDefault: { label: 'Is standaard' },
            name: { label: 'Naam' },
            emailType: { label: 'E-mailtype' },
            subject: { label: 'Onderwerp' },
            textContent: { label: 'Tekstvariant van e-mail', placeholder: 'Sommige mail clients ondersteunen alleen tekst' },
            senderEmail: { label: 'Verzender' },
        }
    },
    emailTypes: {
        password_reset: 'Wachtwoord herstellen',
        user_activation: 'Accountactivatie',
    },
    authentication: {
        dates: {
            maxDate: {
                placeholder: 'Max datum'
            },
            minDate: {
                placeholder: 'Min datum'
            },
            month: {
                0: 'januari',
                1: 'februari',
                2: 'maart',
                3: 'april',
                4: 'mei',
                5: 'juni',
                6: 'juli',
                7: 'augustus',
                8: 'september',
                9: 'oktober',
                10: 'november',
                11: 'december',
            },
            weekDayShort: {
                friday: 'vr',
                monday: 'ma',
                saturday: 'za',
                sunday: 'zo',
                thursday: 'do',
                tuesday: 'di',
                wednesday: 'wo'
            }
        },
        field: {
            mfa: {
                label: 'Methode',
            },
            code: {
                label: 'Code'
            },
            expiresAt: {
                label: 'Verloopt Op'
            },
            ipAddress: {
                label: 'IP-adres'
            },
            status: {
                label: 'Status',
                value: {
                    expired: 'Verlopen',
                    verified: 'Geverifieerd',
                    waiting: 'In behandeling'
                }
            },
            userAgent: {
                label: 'User Agent'
            }
        }
    },
    multiFactorAuthentication: {
        setup: {
            title: 'Multistapsverificatie instellen',
            step1: {
                title: '1. Download de app',
                description: 'Download een verificatie-app, zoals Google Authenticator, als u deze nog niet heeft.',
            },
            step2: {
                title: '2. Scan de QR-code',
                description: 'Scan deze QR-code met uw verificatie-app.',
            },
            step3: {
                title: '3. Voer uw code in',
                description: 'Voer hier de bevestigingscode in die u ziet in uw verificatie-app.',
            },
            subtitle: 'Na het instellen kunt u met uw verificatie-app altijd veilig inloggen.',
        },
        field: {
            method: {
                label: 'MFA-methode',
                options: {
                    app: 'Verificatie-app',
                    email: 'E-mail'
                }
            },
            counter: {
                label: 'Gebruik',
            },
            activated: {
                label: 'Geverifieerd',
            },
        }
    },
    daycy: {
        week: {
            label: 'wk',
            number: '{{weekNumber}}',
        },
        weekDay: {
            friday: 'vr',
            monday: 'ma',
            saturday: 'za',
            sunday: 'zo',
            thursday: 'do',
            tuesday: 'di',
            wednesday: 'wo'
        },
         month: {
            january: 'januari',
            february: 'februari',
            march: 'maart',
            april: 'april',
            may: 'mei',
            june: 'juni',
            july: 'juli',
            august: 'augustus',
            september: 'september',
            october: 'oktober',
            november: 'november',
            december: 'december',
        },

    },
    pageNotFoundMessage: 'Pagina niet gevonden',
    brandingMessage: 'Powered by Code Yellow',
    startError: {
        label: 'Serverfout ({{errorCode}})',
        maintenance: 'Serveronderhoud. Wacht a.u.b. even...',
        line1: 'Onbekende fout',
        line2: 'Neem a.u.b. contact op met support.',
    },


    milestone: {
        create: {
            title: 'Milestone toevoegen'
        },
        overview: {
            title: 'Milestone',
            addChild: 'Kind toevoegen',
            new: 'NIEUW',
            dragInfo: 'Na het slepen worden milestones standaard als hoofdmilestone neergezet, houd shift ingedrukt om ze in plaats daarvan als kindmilestone neer te zetten.',
        },
        field: {
            id: { label: 'ID' },
            status: {
                label: 'Status',
                options: {
                    not_started: 'Niet gestart',
                    wip: 'In progressie',
                    completed: 'Klaar'
                }
            },
            flagged: {
                label: 'Gevlagd',
                options: {
                    all: 'Beide',
                    yes: 'Gevlagd',
                    no: 'Niet gevlagd',
                }
            },
            onHold: {
                label: 'On hold',
                options: {
                    all: 'Beide',
                    yes: 'On hold',
                    no: 'Niet on hold',
                }
            },
            dueAt: { label: 'Verwacht' },
            name: { label: 'Naam' },
            notes: { label: 'Notities' },
            ticket: { label: 'Ticket' },
            deliveredBy: { label: 'Opgeleverd door' },
            receivedBy: { label: 'Ontvangen door' },
            team: { label: 'Team' },
            project: { label: 'Project' },
            company: { label: 'Bedrijf' },
            createdAt: { label: 'Aangemaakt op' },
            noteThread: { label: 'Notitie thread' },
            ordering: { label: 'Sortering' },
            parent: { label: 'Hoofdmilestone' }
        },
    },
    milestoneStatus: {
        overview: {
            addButton: 'Milestonestatus toevoegen'
        },
        create: {
            title: 'Milestonestatus toevoegen'
        },
        edit: {
            title: 'Milestonestatus aanpassen'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Naam'
            },
            color: {
                label: 'Kleur'
            },
            default: {
                label: 'Standaard'
            }
        }
    },
    timeRegistration: {
        overview: {
            title: 'Entries',
            stat: {
                total_duration: 'Totale Tijdsduur',
                total_monetary_value: 'Totale Waarde (€)',
                duration_per_user: 'Tijdsduur per Gebruiker',
                duration_per_project: 'Tijdsduur per Project',
                duration_per_subproject: 'Tijdsduur per Subproject',
                duration_per_budget: 'Tijdsduur per Budget',
                monetary_value_per_budget: 'Waarde per Budget (€)',
                duration_per_ticket: 'Tijdsduur per Ticket',
                duration_per_day: 'Tijdsduur per Dag',
                unlinked_duration: 'Niet-gekoppelde Tijdsduur',
                total_records: 'Registraties',
                avg_entry_duration: 'Gem. Duur per Registratie',
            },
            exportButton: 'Exporteren',
        },
        create: {
            title: 'Entry toevoegen',
        },
        edit: {
            title: 'Entry aanpassen',
        },
        myTime: {
            title: 'Mijn Tijd',
            collapsed: '({{hours}} uur en {{minutes}} minuten aan toekomstige vrije dagen worden niet getoond)',
            collapse: 'Laat toekomstige vrije dagen zien',
            today: 'Vandaag ({{date}})',
            yesterday: 'Gisteren ({{date}})',
            addButton: 'Entry toevoegen',
            addHolidayButton: 'Vakantie toevoegen',
            addHoliday: {
                title: 'Vakantie toevoegen',
            },
            isAltered: 'Deze tijdregistratie is aangepast door de administratie.',
            isUnlinked: 'Deze registratie is nog niet gekoppeld aan een subproject (of project) en telt daarom nog niet mee voor een budget of project. Koppel een subproject om deze af te ronden.',
            lastWeekDay: {
                monday: 'Afgelopen maandag ({{date}})',
                tuesday: 'Afgelopen dinsdag ({{date}})',
                wednesday: 'Afgelopen woensdag ({{date}})',
                thursday: 'Afgelopen donderdag ({{date}})',
                friday: 'Afgelopen vrijdag ({{date}})',
                saturday: 'Afgelopen zaterdag ({{date}})',
                sunday: 'Afgelopen zondag ({{date}})',
            },
            weekDay: {
                monday: 'Maandag {{date}}',
                tuesday: 'Dinsdag {{date}}',
                wednesday: 'Woensdag {{date}}',
                thursday: 'Donderdag {{date}}',
                friday: 'Vrijdag {{date}}',
                saturday: 'Zaterdag {{date}}',
                sunday: 'Zondag {{date}}',
            },
            changeDate: 'Datum aanpassen',
        },
        field: {
            id: { label: 'ID' },
            projects: { label: 'Projecten' },
            user: { label: 'Gebruiker' },
            projectsOrTickets: { label: 'Projecten of tickets' },
            subprojectsOrTickets: { label: 'Subprojecten of tickets' },
            subprojects: { label: 'Subprojecten' },
            budgets: { label: 'Budgetten' },
            tickets: { label: 'Tickets' },
            description: { label: 'Omschrijving' },
            date: { label: 'Datum' },
            startedAt: { label: 'Gestart' },
            endedAt: { label: 'Gestopt' },
            duration: { label: 'Tijdsduur' },
            projectTeam: { label: 'Projectteam' },
            userTeam: { label: 'Gebruikersteam' }
        },
    },
    ticket: {
        overview: {
            title: 'Tickets',
        },
        timePerUser: {
            title: 'Tijd per gebruiker',
        },
        field: {
            number: {
                label: 'Ticket',
            },
            id: {
                label: 'ID'
            },
            title: {
                label: 'Titel'
            },
            assignedTo: {
                label: 'Toegewezen aan'
            },
            timeSpent: {
                label: 'Tijd gespendeerd'
            },
            aiSpend: {
                label: 'AI-uitgaven'
            },
            person: {
                label: 'Persoon'
            },
            progress: {
                label: 'Voortgang',
                empty: 'Ticket is niet EBSed!',
                spentLabel: 'Besteed',
                plannedLabel: 'Gepland',
                percentageLabel: 'Voortgang',
                overLabel: 'over schatting',
            },
        },
        aiSpend: {
            heading: 'AI-uitgaven',
            title: 'AI-uitgaven per verzoek (Synapse)',
            loggedAt: { label: 'Gelogd op' },
            model: { label: 'Model' },
            callType: { label: 'Type verzoek' },
            tokens: { label: 'Tokens' },
            duration: { label: 'Duur' },
            spend: { label: 'Uitgaven' },
            refreshDetail: 'Details verversen',
            perKey: {
                title: 'AI-uitgaven per key',
                key: 'Key',
                requests: 'Verzoeken',
                tokens: 'Tokens',
                duration: 'Actieve tijd',
                spend: 'Uitgaven',
                lastRequest: 'Laatste verzoek',
                empty: 'Nog geen AI-sessies gesynchroniseerd voor dit ticket.',
            },
        },
    },
    tag: {
        overview: {
            addButton: 'Tag toevoegen'
        },
        create: {
            title: 'Tag toevoegen'
        },
        edit: {
            title: 'Tag aanpassen'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Naam'
            },
        },
    },
    entity: {
         overview: {
            title: 'Entiteiten',
            addButton: 'Entiteit toevoegen',
        },
        create: {
            title: 'Entiteit toevoegen',
        },
        edit: {
            title: 'Entiteit bewerken',
        },
        field: {
             name: {
                 label: 'Naam'
             }
        }
    },
    company: {
        overview: {
            title: 'Bedrijven',
            addButton: 'Bedrijf toevoegen'
        },
        create: {
            title: 'Bedrijf toevoegen'
        },
        edit: {
            title: 'Bewerk bedrijf'
        },
        viewport: {
            title: 'Klant',
            editCompany: 'Bewerk bedrijf',
            addContact: 'Contact toevoegen',
            header: {
                mainContact: 'Hoofdcontact',
                responsible: 'Verantwoordelijke'
            },
            kpi: {
                activeContracts: 'Actieve contracten',
                hoursThisMonth: 'Uren deze maand',
                hoursTotal: 'Uren totaal'
            },
            section: {
                contracts: 'Contracten',
                projects: 'Projecten',
                budgets: 'Budgetten',
                subprojects: 'Subprojecten',
                hours: 'Geregistreerde uren',
                contacts: 'Contacten'
            },
            contract: {
                invoice: 'Facturering',
                budgets: 'Budgetten',
                leads: 'Leads'
            },
            budget: {
                add: 'Budget toevoegen',
                subprojects: 'Subprojecten',
                usage: 'Gebruik',
                manageLink: 'Beheer budgetten en subprojecten op de klantpagina →',
                legacyAllocation: 'Dit budget is via een verouderde percentageverdeling aan dit project gekoppeld',
                showFinished: 'Afgeronde tonen'
            },
            subproject: {
                add: 'Subproject toevoegen',
                ownBudget: 'Eigen budget',
                project: 'Project',
                budget: 'Budget',
                showCompleted: 'Afgeronde tonen',
                openPlanning: 'Open de planning voor dit subproject'
            },
            project: {
                addProject: 'Project toevoegen',
                addBudget: 'Budget',
                addSubproject: 'Subproject',
                delete: 'Project verwijderen',
                deleteBlocked: 'Dit project heeft tijdregistraties, merge het in een ander project',
                deleteFailed: 'Project kon niet worden verwijderd',
                deleteModal: {
                    title: 'Project {name} verwijderen',
                    explanation: 'Weet je zeker dat je {name} wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
                    confirm: 'Verwijderen',
                },
                merge: {
                    button: 'In een ander project samenvoegen',
                    failed: 'Projecten konden niet worden samengevoegd',
                },
                mergeModal: {
                    title: '{name} in een ander project samenvoegen',
                    explanation: 'Alles op {name} — tijdregistraties, subprojecten, planning en reacties — verhuist naar het gekozen project. {name} verdwijnt daarna. Dit kan niet ongedaan worden gemaakt.',
                },
                type: {
                    support: 'Support',
                    fixed_fee: 'Vaste prijs',
                    unpaid: 'Geen budget'
                },
                team: 'Team',
                budget: 'Budget'
            },
            hours: {
                thisMonth: 'Deze maand',
                lastMonth: 'Vorige maand',
                total: 'Totaal',
                budgetHours: 'Budgeturen',
                perMonth: '/ maand',
                noData: 'Geen uren geregistreerd in de afgelopen 12 maanden.',
                chartHint: 'Beweeg over een maand voor details.'
            },
            contact: {
                name: 'Naam',
                roles: 'Rollen',
                main: 'Hoofdcontact',
                responsible: 'Verantwoordelijke',
                onContracts: 'Rol bij {{contracts}} contract(en)'
            },
            empty: {
                contracts: 'Nog geen contracten. Voeg het eerste contract toe via "Contract toevoegen".',
                projects: 'Nog geen projecten voor deze klant.',
                budgets: 'Nog geen budgetten. Voeg het eerste budget toe via "Budget toevoegen" of vanaf een project.',
                finishedBudgets: 'Alle budgetten zijn afgerond. Zet "Afgeronde tonen" aan om ze te zien.',
                subprojects: 'Nog geen subprojecten. Voeg het eerste subproject toe via "Subproject toevoegen" of vanaf een project.',
                completedSubprojects: 'Alle subprojecten zijn afgerond. Zet "Afgeronde tonen" aan om ze te zien.',
                contacts: 'Nog geen contacten. Voeg het eerste contact toe via "Contact toevoegen".'
            },
            rightPane: {
                placeholder: 'Selecteer een item in het overzicht om de details te bekijken en te bewerken.',
                newContract: 'Nieuw contract',
                newBudget: 'Nieuw budget',
                newSubproject: 'Nieuw subproject',
                newProject: 'Nieuw project'
            },
            unsavedChanges: {
                withName: 'Je hebt niet-opgeslagen wijzigingen op {{label}} "{{name}}". Wil je deze weggooien?',
                withoutName: 'Je hebt niet-opgeslagen wijzigingen op deze {{label}}. Wil je deze weggooien?',
                company: 'Je hebt niet-opgeslagen wijzigingen op deze klant. Wil je deze weggooien?',
                label: {
                    contact: 'contact',
                    contract: 'contract',
                    budget: 'budget',
                    subproject: 'subproject',
                    project: 'project',
                },
            },
            error: {
                title: 'Kon deze klant niet laden',
                fetchFailed: 'Er ging iets mis bij het laden van de klantgegevens. Controleer je rechten en probeer het opnieuw.',
                saveFailed: 'Opslaan mislukt. Controleer het formulier en je rechten en probeer het opnieuw.'
            }
        },
        field: {
            name: {
                label: 'Naam'
            },
            shortName: {
                label: 'Korte Naam'
            },
            mainContact: {
                label: 'Hoofdcontact'
            },
            responsible: {
                label: 'Verantwoordelijke'
            },
            qaEmail: {
                label: 'QA e-mail'
            },
            communicationRhythm: {
                label: 'Communicatieritme'
            },
            invoiceAgreement: {
                label: 'Facturateafspraken'
            },
            reportingAgreement: {
                label: 'Rapportageafspraken'
            },
            responsibleTeam: {
                label: 'Verantwoordelijk team'
            },
            contracts: {
                label: 'Contracten'
            },
            budgets: {
                label: 'Budgetten',
                thisMonth: 'deze maand',
                total: 'totaal',
            },
            addContract: {
                label: 'Contract toevoegen'
            }
        }
    },
    project: {
        create: {
            title: 'Project toevoegen'
        },
        edit: {
            title: 'Project bewerken'
        },
        overview: {
            addButton: 'Project toevoegen',
            title: 'Projecten'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Naam'
            },
            team: {
                label: 'Team',
            },
            company: {
                label: 'Bedrijf'
            },
            quotationLink: {
                label: 'Offerte'
            },
            hasActiveBudget: {
                label: 'Heeft actief budget'
            },
            projectLead: {
                label: 'Projectlead'
            },
            teamMember: {
                label: 'Projectlid'
            },
            hidden: {
                label: 'Verborgen (in Mijn Tijd)',
                options: {
                    all: 'Alle',
                    visible: 'Zichtbaar',
                    hidden: 'Verborgen'
                }
            }
        }
    },
    planningMilestone: {
        create: {
            title: 'Mijlpaal toevoegen'
        },
        edit: {
            title: 'Mijlpaal bewerken'
        },
        field: {
            name: {
                label: 'Naam'
            },
            type: {
                label: 'Type'
            },
            status: {
                label: 'Status'
            },
            project: {
                label: 'Project'
            },
            startDate: {
                label: 'Startdatum'
            },
            deadline: {
                label: 'Deadline'
            },
            description: {
                label: 'Omschrijving'
            },
            order: {
                label: 'Volgorde'
            }
        }
    },
    planningTicket: {
        create: {
            title: 'Ticket toevoegen'
        },
        edit: {
            title: 'Ticket bewerken'
        },
        field: {
            title: {
                label: 'Titel'
            },
            status: {
                label: 'Status'
            },
            assignee: {
                label: 'Toegewezen aan'
            },
            estimatedHours: {
                label: 'Geschatte uren'
            },
            spentHours: {
                label: 'Gewerkte uren'
            },
            scheduledStart: {
                label: 'Geplande start'
            },
            scheduledEnd: {
                label: 'Gepland einde'
            },
            description: {
                label: 'Omschrijving'
            },
            order: {
                label: 'Volgorde'
            }
        }
    },
    contact: {
        overview: {
            addButton: 'Contact toevoegen',
            title: 'Contacten'
        },
        create: {
            title: 'Contact toevoegen'
        },
        edit: {
            title: 'Contact bewerken'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Naam'
            },
            company: {
                label: 'Bedrijf'
            },
            fullName: {
                label: 'Naam'
            },
            firstName: {
                label: 'Voornaam'
            },
            lastName: {
                label: 'Achternaam'
            }
        }
    },
    team: {
        overview: {
            addButton: 'Team toevoegen'
        },
        create: {
            title: 'Team toevoegen'
        },
        edit: {
            title: 'Team bewerken'
        },
        field: {
            id: {
                label: 'ID'
            },
            company: {
                label: 'Bedrijf'
            },
            name: {
                label: 'Naam'
            }
        }
    },
    history: {
        modal: {
            milestone: {
                title: 'Aanpassingen aan milestone'
            }
        }
    },
    phabricator: {
        linked: 'Gelinkt met Phabricator'
    },
    server: {
        overview: {
            addButton: 'Server toevoegen',
            title: 'Serveroverzicht'
        },
        create: {
            title: 'Server toevoegen'
        },
        edit: {
            title: 'Server aanpassen'
        },
        field: {
            id: {
                label: 'ID'
            },
            serverUrl: {
                label: 'Server URL'
            },
            company: {
                label: 'Bedrijf'
            },
            name: {
                label: 'Naam'
            },
            iaeVersion: {
                label: 'IAE versie'
            },
            branch: {
                label: 'Branch'
            },
            softwareVersion: {
                label: 'Software versie'
            },
            buildDate: {
                label: 'Builddatum',
            },
            lastRetrievedDate: {
                label: 'Laatst geüpdatet'
            },
            team: {
                label: 'Team'
            },
            commitId: {
                label: 'Commit Hash'
            },
            commitNumber: {
                label: 'Commit Number'
            },
            serverType: {
                label: 'Type',
                option: {
                    staging: 'Staging',
                    uat: 'UAT',
                    production: 'Productie'
                }
            },
            backups: {
                label: 'Backups',
                disabled: 'Uitgeschakeld',
                error: 'Geen backup gevonden',
                enabled: {
                    label: 'Backups',
                    option: {
                        enabled: 'Ingeschakeld',
                        both: 'Beide',
                        disabled: 'Uitgeschakeld'
                    }
                },
                type: {
                    label: 'Backup type',
                },
                date: {
                    label: 'Laatste backup gemaakt',
                },
                size: {
                    label: 'Laatste backup grootte (min. in bytes)',
                },
            },
            error: {
                label: 'Error'
            }
        }
    },
    thread: {
        field: {
            notes: {
                none: 'Geen notities',
                more: '({{count}} meer)',
            },
        },
    },
    note: {
        field: {
            contents: { label: 'Inhoud' },
        },
    },
    module: {
        create: {
            title: 'Module toevoegen'
        },
        edit: {
            title: 'Module bewerken'
        },
        field: {
            id: {
                label: 'Id',
            },
            name: {
                label: 'Naam'
            },
            team: {
                label: 'Team'
            },
            callSign: {
                label: 'Call Sign'
            },
            description: {
                label: 'Beschrijving & Relevant process'
            },
            origin: {
                label: 'Origine project'
            },
            logo: {
                label: 'Logo'
            }
        }
    },
     chapter: {
        overview: {
            addButton: 'Hoofdstuk'
        },
        edit: {
            title: 'Hoofdstuk bewerken'
        },
        create: {
            title: 'Hoofdstuk toevoegen'
        },
        field: {
            order: {
                label: 'Volgorde'
            },
            name: {
                label: 'Naam'
            }
        }
    },
    document: {
        edit: {
            title: 'Bewerk document'
        },
        field: {
            chapter: {
                label: 'Hoofddstuk'
            },
            order: {
                label: 'Volgorde'
            },
            name: {
                label: 'Naam'
            },
            responsible: {
                label: 'Verantwoordelijke persoon'
            },
            documentUrl: {
                label: 'Url'
            },
            lastChangedDate: {
              label: 'Laatste verandering'
            },
            lastRevisionDate: {
                label: 'Laaste revisiedatum'
            },
            type: {
                label: 'Documenttype',
                option: {
                    document: 'Document',
                    register: 'Register',
                    form: 'Form',
                    process: 'Proces'
                }
            }
        },
        create: {
            title: 'Document toevoegen'
        }
    },
    workingStatus: {
        working: 'Aan het werk aan {{subject}} sinds {{startedAt}}',
        notWorking: 'Niet aan het werk',
        unspecified: 'ongespecificeerd',
    },
    contract: {
        overview: {
            addButton: 'Contract toevoegen',
            title: 'Contracten'
        },
        create: {
            title: 'Contract toevoegen'
        },
        edit: {
            title: 'Contract bewerken',
            sections: {
                project: 'Project',
                info: 'Projectinfo',
                responsibilities: 'Verantwoordelijkheden',
                budgets: 'Budgetten'
            },
            budgets: {
                terms: 'Voorwaarden',
                allocation: 'Projecttoewijzing',
                addAllocation: 'Toewijzen aan project',
                addType: {
                    'fixed fee': 'Vast budget toevoegen',
                    support: 'Supportbudget toevoegen',
                    recurring: 'Terugkerend budget toevoegen',
                },
                addSubproject: 'Subproject toevoegen',
            }
        },
        field: {
            entity: {
                label: 'Entiteit'
            },
            company: {
                label: 'Bedrijf'
            },
            title: {
                label: 'Titel'
            },
            reference: {
                label: 'Referentie'
            },
            quotation: {
                label: 'Offerte'
            },
            description: {
                label: 'Omschrijving'
            },
            quotationLink: {
                label: 'Link offerte'
            },
            signedPdf: {
                label: 'Getekende offerte'
            },
            customerContact: {
                label: 'Verantwoordelijke klant'
            },
            team: {
                label: 'Team'
            },
            projectLead: {
                label: 'Project Lead'
            },
            devLead: {
                label: 'Dev lead'
            },
            uxdLead: {
                label: 'UXD Lead'
            },
            status: {
                label: 'Status'
            },
            budgetType: {
                label: 'Budgettype'
            },
            type: {
                label: 'Type'
            },
            startDate: {
                label: 'Startdatum'
            },
            endDate: {
                label: 'Einddatum'
            },
            invoiceFrequency: {
                label: 'Factuurfrequentie'
            },
            paymentDays: {
                label: 'Betaaltermijn (dagen)'
            }
        },
        status: {
            'quotation draft': 'Offerte draft',
            'quotation sent': 'Offerte verstuurd',
            'quotation on hold': 'Offerte on hold',
            'quotation rejected': 'Offerte afgekeurd',
            'contract active': 'Contract actief',
            'contract finished': 'Contract af'
        }
    },
    budget: {
        create: {
            title: 'Budget toevoegen'
        },
        edit: {
            title: 'Budget bewerken'
        },
        field: {
            name: {
                label: 'Naam'
            },
            type: {
                label: 'Type'
            },
            description: {
                label: 'Beschrijving'
            },
            startDate: {
                label: 'Startdatum'
            },
            endDate: {
                label: 'Einddatum'
            },
            budgetMoney: {
                label: 'Budget'
            },
            budgetHours: {
                label: 'Urenbudget'
            },
            extraHoursArePaid: {
                label: 'Extra uren zijn betaald'
            },
            budgetHourlyRate: {
                label: 'Uurtarief voor extra uren'
            },
            budgetHourlyMaxHours: {
                label: 'Maximaal aantal extra uren'
            },
            project: {
                label: 'Project'
            },
            contract: {
                label: 'Contract'
            },
            status: {
                label: 'Status'
            },
            hourlyRate: {
                label: 'Uurtarief'
            },
            minHours: {
                label: 'Minimum uren per maand'
            },
            maxHours: {
                label: 'Maximum uren per maand'
            }
        }
    },
    subproject: {
        create: {
            title: 'Subproject toevoegen'
        },
        edit: {
            title: 'Subproject bewerken'
        },
        field: {
            name: {
                label: 'Naam'
            },
            budget: {
                label: 'Budget'
            },
            budgetHours: {
                label: 'Eigen urenbudget'
            },
            description: {
                label: 'Omschrijving'
            },
            project: {
                label: 'Project'
            },
            type: {
                label: 'Type'
            },
            status: {
                label: 'Status',
                options: {
                    planning: 'Planning',
                    active: 'Actief',
                    completed: 'Klaar',
                    on_hold: 'On hold',
                }
            },
            startDate: {
                label: 'Startdatum'
            },
            deadline: {
                label: 'Deadline'
            }
        }
    },
    budgetProject: {
        field: {
            budget: {
                label: 'Budget'
            }
        }
    }
};
